(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["intro-video-overlay"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('intro-video-overlay')) {
    customElements.define(
      'intro-video-overlay',
      class IntroVideoOverlay extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          const first = document.querySelector('intro-video-overlay');
          if (first != null && first !== this) {
            this.setAttribute('dismissed', '');
            this.setAttribute('aria-hidden', 'true');
            return;
          }

          this.video = this.querySelector('video');
          this.unmuteBtn = this.querySelector('.intro-video-overlay__unmute');
          this.skipBtn = this.querySelector('.intro-video-overlay__skip');
          this.labels = {
            unmute: this.dataset.labelUnmute,
            mute: this.dataset.labelMute,
          };

          if (!this.video) {
            this.dismiss();
            return;
          }

          this.video.muted = true;
          this.video.defaultMuted = true;
          this.video.playsInline = true;
          this.video.loop = false;
          this.video.controls = false;
          this.video.setAttribute('playsinline', '');
          this.video.setAttribute('webkit-playsinline', '');
          this.video.disablePictureInPicture = true;

          document.documentElement.classList.add('intro-video-overlay-lock');
          this.tryPlay();

          this.unmuteBtn.addEventListener('click', () => this.toggleMute());
          this.skipBtn.addEventListener('click', () => this.dismiss());
          this.video.addEventListener('ended', () => this.dismiss());
        }

        tryPlay() {
          const playPromise = this.video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }

        toggleMute() {
          this.video.muted = !this.video.muted;
          if (this.video.muted) {
            this.unmuteBtn.setAttribute('aria-pressed', 'false');
            this.unmuteBtn.setAttribute('aria-label', this.labels.unmute);
          } else {
            this.unmuteBtn.setAttribute('aria-pressed', 'true');
            this.unmuteBtn.setAttribute('aria-label', this.labels.mute);
            this.tryPlay();
          }
        }

        dismiss() {
          if (this.hasAttribute('dismissed')) return;
          this.setAttribute('dismissed', '');
          this.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('intro-video-overlay-lock');
          if (this.video) {
            this.video.pause();
            this.video.muted = true;
          }
        }

        disconnectedCallback() {
          document.documentElement.classList.remove('intro-video-overlay-lock');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
